<template>
  <div class="customerstories-container1">
    <app-navigation></app-navigation>
    <section id="hero-section" aria-labelledby="hero-heading" class="korpus-hero-section">
      <div class="hero-container1">
        <div class="hero-content-panel">
          <h1 id="hero-heading" class="visually-hidden">
            {{ $t('customerStories.hero.srTitle') }}
            <span v-html="rawzq2q"></span>
          </h1>
          <h2 class="hero-title">
            {{ $t('customerStories.hero.title') }}
            <span v-html="raw2v4n"></span>
          </h2>
          <p class="hero-lead">
            {{ $t('customerStories.hero.lead') }}
            <span v-html="rawt4zw"></span>
          </p>
          <div class="hero-badge-strip">
            <span class="hero-badge3">
              <svg width="16" xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 24 24">
                <path d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z"
                  fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
              <span>
                {{ $t('common.oneClick') }}
                <span v-html="rawl7yd"></span>
              </span>
            </span>
            <span class="hero-badge3">
              <svg width="16" xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 24 24">
                <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M12 20v2m0-20v2m5 16v2m0-20v2M2 12h2m-2 5h2M2 7h2m16 5h2m-2 5h2M20 7h2M7 20v2M7 2v2"></path>
                  <rect x="4" y="4" rx="2" width="16" height="16"></rect>
                  <rect x="8" y="8" rx="1" width="8" height="8"></rect>
                </g>
              </svg>
              <span>
                {{ $t('common.restApi') }}
                <span v-html="rawhw4f"></span>
              </span>
            </span>
            <span class="hero-badge3">
              <svg width="16" xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 24 24">
                <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path
                    d="M9.671 4.136a2.34 2.34 0 0 1 4.659 0a2.34 2.34 0 0 0 3.319 1.915a2.34 2.34 0 0 1 2.33 4.033a2.34 2.34 0 0 0 0 3.831a2.34 2.34 0 0 1-2.33 4.033a2.34 2.34 0 0 0-3.319 1.915a2.34 2.34 0 0 1-4.659 0a2.34 2.34 0 0 0-3.32-1.915a2.34 2.34 0 0 1-2.33-4.033a2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915"
                  ></path>
                  <circle r="3" cx="12" cy="12"></circle>
                </g>
              </svg>
              <span>
                {{ $t('common.machinePark') }}
                <span v-html="rawareg"></span>
              </span>
            </span>
          </div>
        </div>
        <div class="hero-visual-panel">
          <div class="hero-visual-wrapper">
            <img alt="CNC machine in action, precisely cutting a wooden panel with sawdust flying" src="https://images.pexels.com/photos/7480234/pexels-photo-7480234.jpeg?auto=compress&amp;cs=tinysrgb&amp;h=650&amp;w=940" loading="eager"/>
            <div class="hero-metric-chip">
              <svg width="20" xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24">
                <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M16 7h6v6"></path>
                  <path d="m22 7l-8.5 8.5l-5-5L2 17"></path>
                </g>
              </svg>
              <span>{{ $t('customerStories.hero.metricChip') }}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="customer-quotes-section" aria-labelledby="quotes-heading" class="korpus-quotes-section">
      <div class="quotes-container">
        <div class="quotes-panel">
          <div class="quotes-header">
            <h2 id="quotes-heading" class="section-title">{{ $t('customerStories.quotes.title') }}</h2>
            <div role="tablist" class="quotes-tabs">
              <button role="tab" aria-selected="true" data-category="all" class="active quote-tab">
                {{ $t('customerStories.quotes.tabs.all') }}
                <span v-html="rawx3vh"></span>
              </button>
              <button role="tab" aria-selected="false" data-category="shops" class="quote-tab">
                {{ $t('customerStories.quotes.tabs.shops') }}
                <span v-html="rawcmm4"></span>
              </button>
              <button role="tab" aria-selected="false" data-category="factories" class="quote-tab">
                {{ $t('customerStories.quotes.tabs.factories') }}
                <span v-html="raw00hw"></span>
              </button>
              <button role="tab" aria-selected="false" data-category="integrations" class="quote-tab">
                {{ $t('customerStories.quotes.tabs.integrations') }}
                <span v-html="rawv0kj"></span>
              </button>
            </div>
          </div>
          <div class="quotes-grid">
            <article data-category="shops" class="quote-card">
              <blockquote class="quote-text">
                &quot;{{ $t('customerStories.quotes.items[0].text') }}&quot;
                <span v-html="raw1sv9"></span>
              </blockquote>
              <footer class="quote-author">
                <cite>Jeroen van Dijk</cite>
                <span class="author-role">{{ $t('customerStories.quotes.items[0].role') }}</span>
              </footer>
            </article>
            <article data-category="factories" class="quote-card">
              <blockquote class="quote-text">
                &quot;{{ $t('customerStories.quotes.items[1].text') }}&quot;
                <span v-html="rawrews"></span>
              </blockquote>
              <footer class="quote-author">
                <cite>Anna Peeters</cite>
                <span class="author-role">{{ $t('customerStories.quotes.items[1].role') }}</span>
              </footer>
            </article>
            <article data-category="shops" class="quote-card">
              <blockquote class="quote-text">
                &quot;{{ $t('customerStories.quotes.items[2].text') }}&quot;
                <span v-html="rawvazc"></span>
              </blockquote>
              <footer class="quote-author">
                <cite>Koen Martens</cite>
                <span class="author-role">{{ $t('customerStories.quotes.items[2].role') }}</span>
              </footer>
            </article>
            <article data-category="integrations" class="quote-card">
              <blockquote class="quote-text">
                &quot;{{ $t('customerStories.quotes.items[3].text') }}&quot;
                <span v-html="rawfhw6"></span>
              </blockquote>
              <footer class="quote-author">
                <cite>Pieter De Wit</cite>
                <span class="author-role">{{ $t('customerStories.quotes.items[3].role') }}</span>
              </footer>
            </article>
            <article data-category="shops" class="quote-card">
              <blockquote class="quote-text">
                &quot;{{ $t('customerStories.quotes.items[4].text') }}&quot;
                <span v-html="rawognh"></span>
              </blockquote>
              <footer class="quote-author">
                <cite>Sofie Claes</cite>
                <span class="author-role">{{ $t('customerStories.quotes.items[4].role') }}</span>
              </footer>
            </article>
            <article data-category="factories" class="quote-card">
              <blockquote class="quote-text">
                &quot;{{ $t('customerStories.quotes.items[5].text') }}&quot;
                <span v-html="rawmcsc"></span>
              </blockquote>
              <footer class="quote-author">
                <cite>Bram Hendriks</cite>
                <span class="author-role">{{ $t('customerStories.quotes.items[5].role') }}</span>
              </footer>
            </article>
            <article data-category="factories" class="quote-card">
              <blockquote class="quote-text">
                &quot;{{ $t('customerStories.quotes.items[6].text') }}&quot;
                <span v-html="rawmtdb"></span>
              </blockquote>
              <footer class="quote-author">
                <cite>Lotte Verbeek</cite>
                <span class="author-role">{{ $t('customerStories.quotes.items[6].role') }}</span>
              </footer>
            </article>
            <article data-category="integrations" class="quote-card">
              <blockquote class="quote-text">
                &quot;{{ $t('customerStories.quotes.items[7].text') }}&quot;
                <span v-html="rawwzbf"></span>
              </blockquote>
              <footer class="quote-author">
                <cite>Maarten Kuipers</cite>
                <span class="author-role">{{ $t('customerStories.quotes.items[7].role') }}</span>
              </footer>
            </article>
          </div>
        </div>
      </div>
    </section>
    <section id="impact-metrics-section" aria-labelledby="metrics-heading" class="korpus-metrics-section">
      <div class="metrics-container">
        <div class="metrics-header">
          <h2 id="metrics-heading" class="section-title">
            {{ $t('customerStories.metrics.title') }}
            <span v-html="rawc3mc"></span>
          </h2>
          <div class="metrics-badge-strip">
            <span class="metric-badge">
              <svg width="16" xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 24 24">
                <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
              <span>
                {{ $t('common.oneClick') }}
                <span v-html="raw9s5r"></span>
              </span>
            </span>
            <span class="metric-badge">
              <svg width="16" xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 24 24">
                <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M12 20v2m0-20v2m5 16v2m0-20v2M2 12h2m-2 5h2M2 7h2m16 5h2m-2 5h2M20 7h2M7 20v2M7 2v2"></path>
                  <rect x="4" y="4" rx="2" width="16" height="16"></rect>
                  <rect x="8" y="8" rx="1" width="8" height="8"></rect>
                </g>
              </svg>
              <span>
                {{ $t('common.restApi') }}
                <span v-html="rawspj8"></span>
              </span>
            </span>
            <span class="metric-badge">
              <svg width="16" xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 24 24">
                <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M9.671 4.136a2.34 2.34 0 0 1 4.659 0a2.34 2.34 0 0 0 3.319 1.915a2.34 2.34 0 0 1 2.33 4.033a2.34 2.34 0 0 0 0 3.831a2.34 2.34 0 0 1-2.33 4.033a2.34 2.34 0 0 0-3.319 1.915a2.34 2.34 0 0 1-4.659 0a2.34 2.34 0 0 0-3.32-1.915a2.34 2.34 0 0 1-2.33-4.033a2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915"></path>
                  <circle r="3" cx="12" cy="12"></circle>
                </g>
              </svg>
              <span>
                {{ $t('common.machinePark') }}
                <span v-html="rawqv2v"></span>
              </span>
            </span>
          </div>
        </div>
        <div class="metrics-featured-card">
          <div class="featured-content">
            <div class="featured-metric">
              <span class="metric-number">6</span>
              <span class="metric-unit">{{ $t('customerStories.metrics.featured.unit') }}</span>
            </div>
            <div class="featured-text">
              <h3 class="metric-label">{{ $t('customerStories.metrics.featured.label') }}</h3>
              <p class="metric-detail">
                <span>{{ $t('customerStories.metrics.featured.detail') }}</span>
                <br />
                <span v-html="raw7hfc"></span>
              </p>
            </div>
          </div>
        </div>
        <div class="metrics-grid">
          <article class="metric-card1">
            <svg width="28" xmlns="http://www.w3.org/2000/svg" height="28" viewBox="0 0 24 24" class="metric-icon1">
              <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M12 6v6l4 2"></path>
                <circle r="10" cx="12" cy="12"></circle>
              </g>
            </svg>
            <span class="metric-number">97%</span>
            <h3 class="metric-label">{{ $t('customerStories.metrics.items[0].label') }}</h3>
            <p class="metric-detail">
              {{ $t('customerStories.metrics.items[0].detail') }}
              <span v-html="raw80nh"></span>
            </p>
          </article>
          <article class="metric-card1">
            <svg width="28" xmlns="http://www.w3.org/2000/svg" height="28" viewBox="0 0 24 24" class="metric-icon1">
              <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle r="10" cx="12" cy="12"></circle>
                <circle r="6" cx="12" cy="12"></circle>
                <circle r="2" cx="12" cy="12"></circle>
              </g>
            </svg>
            <span class="metric-number">65%</span>
            <h3 class="metric-label">{{ $t('customerStories.metrics.items[1].label') }}</h3>
            <p class="metric-detail">
              {{ $t('customerStories.metrics.items[1].detail') }}
              <span v-html="rawi921"></span>
            </p>
          </article>
          <article class="metric-card1">
            <svg width="28" xmlns="http://www.w3.org/2000/svg" height="28" viewBox="0 0 24 24" class="metric-icon1">
              <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M16 7h6v6"></path>
                <path d="m22 7l-8.5 8.5l-5-5L2 17"></path>
              </g>
            </svg>
            <span class="metric-number">+40%</span>
            <h3 class="metric-label">{{ $t('customerStories.metrics.items[2].label') }}</h3>
            <p class="metric-detail">
              {{ $t('customerStories.metrics.items[2].detail') }}
              <span v-html="rawhdiv"></span>
            </p>
          </article>
          <article class="metric-card1">
            <svg width="28" xmlns="http://www.w3.org/2000/svg" height="28" viewBox="0 0 24 24" class="metric-icon1">
              <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
            <span class="metric-number">99.8%</span>
            <h3 class="metric-label">{{ $t('customerStories.metrics.items[3].label') }}</h3>
            <p class="metric-detail">
              {{ $t('customerStories.metrics.items[3].detail') }}
              <span v-html="rawlsmf"></span>
            </p>
          </article>
          <article class="metric-card1">
            <svg width="28" xmlns="http://www.w3.org/2000/svg" height="28" viewBox="0 0 24 24" class="metric-icon1">
              <path d="m5 12l7-7l7 7m-7 7V5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
            <span class="metric-number">80%</span>
            <h3 class="metric-label">{{ $t('customerStories.metrics.items[4].label') }}</h3>
            <p class="metric-detail">
              {{ $t('customerStories.metrics.items[4].detail') }}
              <span v-html="rawbfen"></span>
            </p>
          </article>
          <article class="metric-card1">
            <svg width="28" xmlns="http://www.w3.org/2000/svg" height="28" viewBox="0 0 24 24" class="metric-icon1">
              <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="m15.477 12.89l1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526"></path>
                <circle r="6" cx="12" cy="8"></circle>
              </g>
            </svg>
            <span class="metric-number">12%</span>
            <h3 class="metric-label">{{ $t('customerStories.metrics.items[5].label') }}</h3>
            <p class="metric-detail">
              {{ $t('customerStories.metrics.items[5].detail') }}
              <span v-html="raw5f2i"></span>
            </p>
          </article>
          <article class="metric-card1">
            <svg width="28" xmlns="http://www.w3.org/2000/svg" height="28" viewBox="0 0 24 24" class="metric-icon1">
              <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path
                  d="M9.671 4.136a2.34 2.34 0 0 1 4.659 0a2.34 2.34 0 0 0 3.319 1.915a2.34 2.34 0 0 1 2.33 4.033a2.34 2.34 0 0 0 0 3.831a2.34 2.34 0 0 1-2.33 4.033a2.34 2.34 0 0 0-3.319 1.915a2.34 2.34 0 0 1-4.659 0a2.34 2.34 0 0 0-3.32-1.915a2.34 2.34 0 0 1-2.33-4.033a2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915"
                ></path>
                <circle r="3" cx="12" cy="12"></circle>
              </g>
            </svg>
            <span class="metric-number">22%</span>
            <h3 class="metric-label">{{ $t('customerStories.metrics.items[6].label') }}</h3>
            <p class="metric-detail">
              {{ $t('customerStories.metrics.items[6].detail') }}
              <span v-html="rawpqfy"></span>
            </p>
          </article>
          <article class="metric-card1">
            <svg width="28" xmlns="http://www.w3.org/2000/svg" height="28" viewBox="0 0 24 24" class="metric-icon1">
              <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M16 3.128a4 4 0 0 1 0 7.744M22 21v-2a4 4 0 0 0-3-3.87"></path>
                <circle r="4" cx="9" cy="7"></circle>
              </g>
            </svg>
            <span class="metric-number">50%</span>
            <h3 class="metric-label">{{ $t('customerStories.metrics.items[7].label') }}</h3>
            <p class="metric-detail">
              {{ $t('customerStories.metrics.items[7].detail') }}
              <span v-html="raw93o7"></span>
            </p>
          </article>
        </div>
      </div>
    </section>
    <section id="timeline-section" aria-labelledby="timeline-heading" class="korpus-timeline-section">
      <div class="timeline-container1">
        <div class="timeline-header">
          <h2 id="timeline-heading" class="section-title">
            {{ $t('customerStories.timeline.title') }}
            <span v-html="rawh6ki"></span>
          </h2>
          <p class="section-subtitle">
            {{ $t('customerStories.timeline.subtitle') }}
            <span v-html="rawkgal"></span>
          </p>
        </div>
        <div class="timeline-steps">
          <article class="timeline-step2">
            <div class="step-node"><span class="step-number2">1</span></div>
            <div class="step-content1">
              <div class="step-thumbnail">
                <img alt="Craftsman skillfully working with wood in an indoor workshop setting" src="/vlecad_170628_lr_14_sv5_0379-1500w.jpg" loading="lazy" />
              </div>
              <h3 class="step-title1">{{ $t('customerStories.timeline.steps[0].title') }}</h3>
              <p class="step-description">
                {{ $t('customerStories.timeline.steps[0].description') }}
                <span v-html="raw8aqv"></span>
              </p>
            </div>
          </article>
          <article class="timeline-step2">
            <div class="step-node"><span class="step-number2">2</span></div>
            <div class="step-content1">
              <div class="step-thumbnail">
                <img alt="A modern CNC machine control panel used for precise industrial processes indoors" src="/vlecad_170628_lr_42_sv5_0686-1500w.jpg" loading="lazy"/>
              </div>
              <h3 class="step-title1">{{ $t('customerStories.timeline.steps[1].title') }}</h3>
              <p class="step-description">
                {{ $t('customerStories.timeline.steps[1].description') }}
                <span v-html="rawxqa6"></span>
              </p>
            </div>
          </article>
          <article class="timeline-step2">
            <div class="step-node"><span class="step-number2">3</span></div>
            <div class="step-content1">
              <div class="step-thumbnail">
                <img alt="A close-up shot of a CNC machine operating in a workshop with a technician nearby" src="/vlecad-1282-1024x683-1500w.jpg" loading="lazy"/>
              </div>
              <h3 class="step-title1">{{ $t('customerStories.timeline.steps[2].title') }}</h3>
              <p class="step-description">
                {{ $t('customerStories.timeline.steps[2].description') }}
                <span v-html="rawrpcx"></span>
              </p>
            </div>
          </article>
          <article class="timeline-step2">
            <div class="step-node"><span class="step-number2">4</span></div>
            <div class="step-content1">
              <div class="step-thumbnail">
                <img alt="Close-up of beverage cans on an automated assembly line in a factory" src="/vlecad_170628_lr_10_sv5_0320-1500w.jpg" loading="lazy" />
              </div>
              <h3 class="step-title1">{{ $t('customerStories.timeline.steps[3].title') }}</h3>
              <p class="step-description">
                {{ $t('customerStories.timeline.steps[3].description') }}
                <span v-html="rawp9yc"></span>
              </p>
            </div>
          </article>
        </div>
      </div>
    </section>
    <section id="workshop-imaging-section" aria-labelledby="workshop-heading" class="korpus-workshop-section">
      <div>
        <div class="customer_stories-workshop-container">
          <div class="workshop-left">
            <h2 id="workshop-heading" class="section-title">
              {{ $t('customerStories.workshopImaging.title') }}
              <span v-html="rawe4rq"></span>
            </h2>
            <h3 class="workshop-subtitle">
              {{ $t('customerStories.workshopImaging.subtitle') }}
              <span v-html="raw5odz"></span>
            </h3>
            <p class="workshop-intro">
              {{ $t('customerStories.workshopImaging.intro') }}
              <span v-html="rawdsmu"></span>
            </p>
            <div class="workshop-why">
              <h4 class="why-title">{{ $t('customerStories.workshopImaging.whyTitle') }}</h4>
              <p class="why-text">
                {{ $t('customerStories.workshopImaging.whyText') }}
                <span v-html="rawamks"></span>
              </p>
            </div>
            <div class="workshop-image-grid">
              <div class="image-card">
                <img alt="A detailed view of a CNC machine being operated by a person indoors with dim lighting" src="/20250430_122314%20-cnc-1500w.jpg" loading="lazy"/>
                <p class="image-caption">{{ $t('customerStories.workshopImaging.captions[0]') }}</p>
              </div>
              <div class="image-card">
                <img alt="Close-up of a CNC machine carving a wooden surface indoors, showcasing precision equipment" src="/20250429_175035%20-%20nesting%20cnc-1500w.jpg" loading="lazy"/>
                <p class="image-caption">
                  {{ $t('customerStories.workshopImaging.captions[1]') }}
                  <span v-html="rawwslb"></span>
                </p>
              </div>
              <div class="image-card">
                <img alt="An artisan working with precision on a drill machine in a woodworking shop" src="/vlecad_170628_lr_18_sv5_0475-1500w.jpg" loading="lazy"/>
                <p class="image-caption">{{ $t('customerStories.workshopImaging.captions[2]') }}</p>
              </div>
              <div class="image-card">
                <img alt="Three men discussing work in a woodworking shop with CNC machinery in focus" src="/vlecad_170628_lr_42_sv5_0686-1500w.jpg" loading="lazy"/>
                <p class="image-caption">
                  {{ $t('customerStories.workshopImaging.captions[3]') }}
                  <span v-html="rawyx5n"></span>
                </p>
              </div>
            </div>
            <div class="workshop-badge-strip">
              <span class="workshop-badge">{{ $t('common.oneClick') }}</span>
              <span class="workshop-badge">{{ $t('common.restApi') }}</span>
              <span class="workshop-badge">{{ $t('common.machinePark') }}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="about-korpus-section" aria-labelledby="about-heading" class="korpus-about-section">
      <div class="about-container">
        <div class="about-left">
          <div class="about-title-row">
            <h2 id="about-heading" class="section-title">
              {{ $t('customerStories.about.title') }}
              <span v-html="rawr8ci"></span>
            </h2>
            <span class="about-badge-inline">{{ $t('customerStories.about.badge') }}</span>
          </div>
          <div class="about-body-panel">
            <p class="about-lead">
              <span>{{ $t('customerStories.about.lead') }}</span>
              <span v-html="raw2tab"></span>
            </p>
            <h3 class="about-subheading">{{ $t('customerStories.about.subheadings.whyItWorks') }}</h3>
            <p class="about-text">
              <span>{{ $t('customerStories.about.texts.whyItWorks') }}</span>
              <span v-html="rawurc9"></span>
            </p>
            <h3 class="about-subheading">{{ $t('customerStories.about.subheadings.mindsetScale') }}</h3>
            <p class="about-text">
              {{ $t('customerStories.about.texts.mindsetScale') }}
              <span v-html="rawy4az"></span>
            </p>
            <h3 class="about-subheading">{{ $t('customerStories.about.subheadings.foundation') }}</h3>
            <p class="about-text">
              <span>{{ $t('customerStories.about.texts.foundation') }}</span>
              <span v-html="rawfjqw"></span>
            </p>
          </div>
          <div class="about-trust-grid">
            <div class="trust-tile">
              <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" class="trust-icon">
                <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="m15.477 12.89l1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526"></path>
                  <circle r="6" cx="12" cy="8"></circle>
                </g>
              </svg>
              <h4 class="trust-title">{{ $t('customerStories.about.trustTiles[0]') }}</h4>
            </div>
            <div class="trust-tile">
              <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" class="trust-icon">
                <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <circle r="10" cx="12" cy="12"></circle>
                  <circle r="6" cx="12" cy="12"></circle>
                  <circle r="2" cx="12" cy="12"></circle>
                </g>
              </svg>
              <h4 class="trust-title">{{ $t('customerStories.about.trustTiles[1]') }}</h4>
            </div>
            <div class="trust-tile">
              <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" class="trust-icon">
                <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path
                    d="M9.671 4.136a2.34 2.34 0 0 1 4.659 0a2.34 2.34 0 0 0 3.319 1.915a2.34 2.34 0 0 1 2.33 4.033a2.34 2.34 0 0 0 0 3.831a2.34 2.34 0 0 1-2.33 4.033a2.34 2.34 0 0 0-3.319 1.915a2.34 2.34 0 0 1-4.659 0a2.34 2.34 0 0 0-3.32-1.915a2.34 2.34 0 0 1-2.33-4.033a2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915"
                  ></path>
                  <circle r="3" cx="12" cy="12"></circle>
                </g>
              </svg>
              <h4 class="trust-title">{{ $t('customerStories.about.trustTiles[2]') }}</h4>
            </div>
          </div>
        </div>
        <div class="about-right">
          <div class="about-card">
            <div class="about-card-badges">
              <span class="about-card-badge">
                <svg width="16" xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 24 24">
                  <path d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z"
                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
                <span>
                  {{ $t('common.oneClick') }}
                  <span v-html="rawjl8c"></span>
                </span>
              </span>
              <span class="about-card-badge">
                <svg width="16" xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 24 24">
                  <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M12 20v2m0-20v2m5 16v2m0-20v2M2 12h2m-2 5h2M2 7h2m16 5h2m-2 5h2M20 7h2M7 20v2M7 2v2"></path>
                    <rect x="4" y="4" rx="2" width="16" height="16"></rect>
                    <rect x="8" y="8" rx="1" width="8" height="8"></rect>
                  </g>
                </svg>
                <span>
                  {{ $t('common.restApi') }}
                  <span v-html="rawce3w"></span>
                </span>
              </span>
              <span class="about-card-badge">
                <svg width="16" xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 24 24">
                  <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path
                      d="M9.671 4.136a2.34 2.34 0 0 1 4.659 0a2.34 2.34 0 0 0 3.319 1.915a2.34 2.34 0 0 1 2.33 4.033a2.34 2.34 0 0 0 0 3.831a2.34 2.34 0 0 1-2.33 4.033a2.34 2.34 0 0 0-3.319 1.915a2.34 2.34 0 0 1-4.659 0a2.34 2.34 0 0 0-3.32-1.915a2.34 2.34 0 0 1-2.33-4.033a2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915"
                    ></path>
                    <circle r="3" cx="12" cy="12"></circle>
                  </g>
                </svg>
                <span>
                  {{ $t('common.machinePark') }}
                  <span v-html="rawphfh"></span>
                </span>
              </span>
            </div>
            <h3 class="about-card-title">{{ $t('customerStories.about.card.title') }}</h3>
            <p class="about-card-summary">
              {{ $t('customerStories.about.card.summary') }}
              <span v-html="rawr76l"></span>
            </p>
            <router-link to="/contactdemo">
              <div class="btn btn-primary about-card-cta">
                <button @click="scrollToTop">
                  {{ $t('customerStories.about.card.cta') }}
                </button>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </section>
    <app-footer></app-footer>
  </div>
</template>

<script>
import { useHead } from "@vueuse/head";

import AppNavigation from "../components/navigation";
import AppFooter from "../components/footer";

export default {
  name: "Customerstories",
  props: {},
  components: {
    AppNavigation,
    AppFooter,
  },
  setup() {
    // Vue 3 migration: move metaInfo into useHead.
    useHead({
      title: "Customerstories - KORPUS by VLECAD®",
      meta: [
        {
          name: "description",
          content: "Customer stories for KORPUS by VLECAD®: CAD/CAM software that thinks like a craftsman for interior builders and cabinet shops.",
        },
        {
          property: "og:title",
          content: "Customerstories - KORPUS by VLECAD®",
        },
        {
          property: "og:description",
          content: "Customer stories for KORPUS by VLECAD®: CAD/CAM software that thinks like a craftsman for interior builders and cabinet shops.",
        },
        {
          property: "og:image",
          content:
            "https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/ebedf48f-c2b5-4ca6-808d-9d940905bddf/993061ae-1787-4b73-9fda-47262adc60d9?org_if_sml=1&force_format=original",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://hospitable-imperfect-heron-qlicxu.teleporthq.app/customerstories",
        },
      ],
    });
  },
  data() {
    return {
      rawzq2q: " ",
      raw2v4n: " ",
      rawt4zw: " ",
      rawl7yd: " ",
      rawhw4f: " ",
      rawareg: " ",
      rawx3vh: " ",
      rawcmm4: " ",
      raw00hw: " ",
      rawv0kj: " ",
      raw1sv9: " ",
      rawrews: " ",
      rawvazc: " ",
      rawfhw6: " ",
      rawognh: " ",
      rawmcsc: " ",
      rawmtdb: " ",
      rawwzbf: " ",
      rawc3mc: " ",
      raw9s5r: " ",
      rawspj8: " ",
      rawqv2v: " ",
      rawkxyu: " ",
      raw7hfc: " ",
      raw80nh: " ",
      rawi921: " ",
      rawhdiv: " ",
      rawlsmf: " ",
      rawbfen: " ",
      raw5f2i: " ",
      rawpqfy: " ",
      raw93o7: " ",
      rawh6ki: " ",
      rawkgal: " ",
      raw8aqv: " ",
      rawxqa6: " ",
      rawrpcx: " ",
      rawp9yc: " ",
      rawf2cx: " ",
      rawig5k: " ",
      rawf2h7: " ",
      rawism9: " ",
      rawyrso: " ",
      rawn51k: " ",
      raw2de3: " ",
      rawz5jk: " ",
      rawe4rq: " ",
      raw5odz: " ",
      rawdsmu: " ",
      rawamks: " ",
      rawwslb: " ",
      rawyx5n: " ",
      rawr8ci: " ",
      rawtq29: " ",
      raw2tab: " ",
      rawi7xb: " ",
      rawurc9: " ",
      rawy4az: " ",
      rawj0gv: " ",
      rawfjqw: " ",
      rawjl8c: " ",
      rawce3w: " ",
      rawphfh: " ",
      rawr76l: " ",
      rawe3rr: " ",
    };
  },
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }    
  }
};
</script>

<style>
@keyframes heroFadeIn {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes quoteFadeIn {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes metricFadeIn {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
  .hero-content-panel,
  .quote-card,
  .metric-card {
    opacity: 1;
    transform: none;
  }
  .hero-cta:hover,
  .image-card:hover,
  .metric-card:hover {
    transform: none;
  }
}
</style>

<style scoped>
.customerstories-container1 {
  width: 100%;
  display: block;
  min-height: 100vh;
}

.customerstories-container2 {
  display: none;
}

.customerstories-container3 {
  display: contents;
}

.customerstories-container4 {
  display: none;
}

.customerstories-container5 {
  display: contents;
}

.customerstories-container6 {
  display: none;
}

.customerstories-container7 {
  display: contents;
}

.customerstories-thq-korpus-demo-section-elm {
  display: none;
}

.customerstories-thq-demo-form-panel-elm {
  display: none;
}

.customerstories-text37 {
  font-weight: 700;
}

.customerstories-text39 {
  font-weight: 700;
}

.customerstories-text41 {
  font-weight: 700;
}
</style>
